import { Railroad } from 'src/shared/api';
import {
	RailroadDetails,
	RailroadDetailGeneralInformation,
	PayrollOptions,
} from './railroad-detail.models';
import { railroadToOptionalJobFieldsToShow } from 'src/admin-app/shared/optional-fields/optional-fields.utility';

export function railroadFormToRailroad(formValue: RailroadDetails): Railroad {
	let railroad: Railroad;
	if (formValue) {
		const {
			documents,
			contractedRates,
			divisions,
			contacts,
			offeredServices,
			subCodes,
			address = {},
			...details
		} = formValue;

		railroad = {
			documents,
			contractedRates,
			divisions,
			contacts,
			offeredServices,
			subCodes,
			address,
			...details.generalInfo,
			...details.payrollOptions,
			...details.optionalJobFieldsToShow,
		};
	}
	return railroad;
}

export function railroadToRailroadForm(
	railroad: Railroad
): RailroadDetails | null {
	if (railroad) {
		return {
			generalInfo: railroadToGeneralInfo(railroad),
			address: railroad.address,
			documents: railroad.documents || [],
			contacts: railroad.contacts || [],
			divisions: railroad.divisions || [],
			contractedRates: railroad.contractedRates,
			payrollOptions: railroadToPayrollOptions(railroad),
			optionalJobFieldsToShow:
				railroadToOptionalJobFieldsToShow(railroad),
			offeredServices: railroad.offeredServices || [],
			subCodes: railroad.subCodes || [],
		};
	} else {
		return {
			generalInfo: null,
			address: null,
			documents: [],
			contacts: [],
			divisions: [],
			contractedRates: null,
			payrollOptions: null,
			optionalJobFieldsToShow: null,
			offeredServices: [],
			subCodes: [],
		};
	}
}

function railroadToGeneralInfo(
	railroad: Railroad
): RailroadDetailGeneralInformation {
	return {
		id: railroad.id,
		companyName: railroad.companyName,
		code: railroad.code,
		employerIdentificationNumber: railroad.employerIdentificationNumber,
		dailyVehicleFee: railroad.dailyVehicleFee,
		weeklyVehicleFee: railroad.weeklyVehicleFee,
		monthlyVehicleFee: railroad.monthlyVehicleFee,
		billingEmail: railroad.billingEmail,
		divisionLabel: railroad.divisionLabel,
		includeWcrReportInInvoice: railroad.includeWcrReportInInvoice,
		dwrType: railroad.dwrType,
		contractNumber: railroad.contractNumber,
		taskNumber: railroad.taskNumber,
		regularTimeBasis: railroad.regularTimeBasis,
		overtimeBasis: railroad.overtimeBasis,
		isIntegratedWithFlairDocs: railroad.isIntegratedWithFlairDocs,
		showWorkOrderNumberOnInvoice: railroad.showWorkOrderNumberOnInvoice,
		requireReportingForDuty: railroad.requireReportingForDuty,
		class: railroad.class,
	};
}

function railroadToPayrollOptions(railroad: Railroad): PayrollOptions {
	return {
		nonflaggingHourlyRate: railroad.nonflaggingHourlyRate,
		dailyCellPhoneReimbursementRate:
			railroad.dailyCellPhoneReimbursementRate,
		hotelPerDiemA: railroad.hotelPerDiemA,
		mealPerDiemA: railroad.mealPerDiemA,
		hotelPerDiemB: railroad.hotelPerDiemB,
		mealPerDiemB: railroad.mealPerDiemB,
		mealBonusApplies: railroad.mealBonusApplies,
		mileageReimbursed: railroad.mileageReimbursed,
		travelTimeApplies: railroad.travelTimeApplies,
		minimumShiftHours: railroad.minimumShiftHours,
		conferenceCallHourlyRate: railroad.conferenceCallHourlyRate,
		trainingHourlyRate: railroad.trainingHourlyRate,
		travelHourlyRate: railroad.travelHourlyRate,
		drugTestHourlyRate: railroad.drugTestHourlyRate,
	};
}
